import * as React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useDispatch } from "react-redux";
import {
  addProductType,
  removeProductType,
  setStocking,
  setWithQuantityOnly,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { Button } from "@mui/material";
import AppConfirmDialog from "../../app/AppConfirmDialog";

interface DmsProductTypeProps {
  handleNext: any;
  handleBack: any;
  isReInitiateRequest: boolean;
}

const DmsProductType: React.FunctionComponent<DmsProductTypeProps> = ({
  handleBack,
  handleNext,
  isReInitiateRequest,
}) => {
  const dispatch = useDispatch();
  const types = useSelector(
    (state: AppState) => state.dmsReducer.typeToProcess
  );
  const stocking = useSelector((state: AppState) => state.dmsReducer.stocking);
  const { withQtyOnly } = useSelector((state: AppState) => state.dmsReducer);
  const [navigateOpen, setNavigateOpen] = React.useState(false);

  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  React.useEffect(() => {
    if (dmsSetup) {
      if (dmsSetup.productTypes.some((n) => n === "Wholegoods"))
        dispatch(addProductType("Wholegoods"));
    }
  }, []);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
        height={600}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 2,
          }}
        >
          {isReInitiateRequest ? null : (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setNavigateOpen(true);
              }}
            >
              Back
            </Button>
          )}
          <Button
            size="small"
            variant="contained"
            onClick={handleNext}
            disabled={types.length === 0}
          >
            Next
          </Button>
        </Box>
        <FormControl
          sx={{ m: 3 }}
          component="fieldset"
          variant="standard"
          style={{ alignItems: "center" }}
        >
          <FormLabel component="h2" style={{ fontSize: "1.5rem" }}>
            What type of Products do you want to Sync?
          </FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={types.some((i) => i == "Wholegoods")}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(addProductType("Wholegoods"));
                    } else {
                      dispatch(removeProductType("Wholegoods"));
                    }
                  }}
                  name={"Wholegoods"}
                  disabled={
                    dmsSetup &&
                    dmsSetup.productTypes.some((n) => n === "Wholegoods")
                  }
                />
              }
              label={"Wholegoods"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={stocking}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(setStocking(true));
                    } else {
                      dispatch(setStocking(false));
                    }
                  }}
                  name={"Stocking"}
                />
              }
              label={"Stocking Only"}
            />
            <FormControlLabel
              sx={{ display: stocking ? "" : "none" }}
              control={
                <Checkbox
                  checked={withQtyOnly}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(setWithQuantityOnly(true));
                    } else {
                      dispatch(setWithQuantityOnly(false));
                    }
                  }}
                  name={"WithQtyOnly"}
                />
              }
              label={"With Quantity Only"}
            />
          </FormGroup>
        </FormControl>
      </Box>
      <AppConfirmDialog
        headerText="Confirm Navigation"
        bodyText="Are you sure you want to go back? You will lose Manufacturers mapping."
        onFail={() => {
          setNavigateOpen(false);
        }}
        onSuccess={() => {
          setNavigateOpen(false);
          handleBack();
        }}
        handleClose={() => {
          setNavigateOpen(false);
        }}
        isOpen={navigateOpen}
      />
    </>
  );
};

export default DmsProductType;
